import type { Simulation } from '../sim';
import { LETTER_DEFS, type LetterDef } from './letters-defs';

const DEFS_BY_ID = new Map<string, LetterDef>(LETTER_DEFS.map((def) => [def.id, def]));

export function letterDef(id: string): LetterDef | undefined {
  return DEFS_BY_ID.get(id);
}

/** At most one letter a day, in def order — pacing is part of the tutorial. */
export function stepLettersDaily(sim: Simulation): void {
  const state = sim.state;

  const quota = state.letters.quota;
  if (quota && !quota.completed && !quota.failed && sim.week > quota.byWeek) {
    quota.failed = true;
    sim.pushEvent({ kind: 'toast', message: 'HQ quota missed. The board is displeased.' });
  }

  if (state.meta.gameOver) return;
  for (const def of LETTER_DEFS) {
    if (state.letters.delivered.some((letter) => letter.defId === def.id)) continue;
    if (!def.trigger(sim)) continue;
    state.letters.delivered.push({ defId: def.id, deliveredDay: sim.day, read: false });
    def.onDeliver?.(sim);
    sim.pushEvent({ kind: 'letterDelivered', defId: def.id });
    // Auto-opened letters announce themselves; only archive-only mail toasts.
    if (def.autoOpen === false) sim.pushEvent({ kind: 'toast', message: `Mail: ${def.subject}` });
    break;
  }
}
